import { render, staticRenderFns } from "./SubjectSelectDialog.vue?vue&type=template&id=633999e4&scoped=true"
import script from "./SubjectSelectDialog.vue?vue&type=script&lang=js"
export * from "./SubjectSelectDialog.vue?vue&type=script&lang=js"
import style0 from "./SubjectSelectDialog.vue?vue&type=style&index=0&id=633999e4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633999e4",
  null
  
)

export default component.exports